import { NgModule } from '@angular/core';
import { NavigationEnd, RouteConfigLoadEnd, RouteConfigLoadStart, Router, RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { AppRouteGuard } from './shared/common/auth/auth-route-guard';
import { NotificationsComponent } from './shared/layout/notifications/notifications.component';
import { environment } from 'environments/environment';

let routes: Routes = [
    {
        path: 'app',
        component: AppComponent,
        canActivate: [AppRouteGuard],
        canActivateChild: [AppRouteGuard],
        children: [
            {
                path: '',
                children: [
                    { path: 'notifications', component: NotificationsComponent },
                    { path: '', redirectTo: '/projects', pathMatch: 'full' }
                ]
            },
            {
                path: 'main',
                loadChildren: () => import('app/main/main.module').then(m => m.MainModule), //Lazy load main module
                data: { preload: true }
            },
            {
                path: 'admin',
                loadChildren: () => import('app/admin/admin.module').then(m => m.AdminModule), //Lazy load admin module
                data: { preload: true }
            }, {
                path: '**', redirectTo: 'notifications'
            }
        ]
    }
];

// Get current hostname
const hostname = location.hostname.toLowerCase();

if (hostname === environment.WebFacingHost.toLowerCase()){
    routes = [];
}
@NgModule({
    imports: [
        RouterModule.forChild(routes)
    ],
    exports: [RouterModule]
})

export class AppRoutingModule {
    constructor(
        private router: Router
    ) {
        router.events.subscribe((event) => {

            if (event instanceof RouteConfigLoadStart) {
                abp.ui.setBusy();
            }

            if (event instanceof RouteConfigLoadEnd) {
                abp.ui.clearBusy();
            }

            if (event instanceof NavigationEnd) {
                $('meta[property=og\\:url]').attr('content', window.location.href);
                $('#m_aside_left').mOffcanvas().hide();
            }
        });
    }
}
